import { LANGUAGE } from '../constants';
import { Language } from '../types/common';
import type { OptionsType } from '../types/options';

/**
 * 商社コードから商社名を返す。該当する商社が見つからなかったら商社コードをそのまま帰す。
 * @param steelMakerCode [string]
 * @param steelMakers [OptionsType[]]
 * @param language? [Language]
 * @returns [string]
 */
const getSteelMakerName = (steelMakerCode: string, steelMakers: OptionsType[], language?: Language): string => {
  // 商社の検索
  const steelMaker: OptionsType | undefined = steelMakers?.find((maker) => maker.code === steelMakerCode);
  const steelMakerName: string = steelMaker
    ? language
      ? language === LANGUAGE.EN
        ? steelMaker.nameEnglish
          ? steelMaker.nameEnglish
          : steelMaker.nameJapanese
        : steelMaker.nameJapanese
      : steelMaker.nameJapanese
    : steelMakerCode;
  return steelMakerName;
};

export default getSteelMakerName;
